export default __webpack_public_path__ + "static/media/delete_icon.c72dc226.svg";